import * as React from 'react';
import * as $ from 'jquery';

import { useElementsReorderingHook } from '../ts/DragDropCommon';

export function RemovableBlockContainer(props: {
    id?: any;
    showReorderButton?: boolean;
    children?: React.ReactNode | React.ReactNode[];
    onRemove?(id: any): void;
}) {
    let reorderButton: React.JSX.Element;

    if (props.showReorderButton) {
        reorderButton = (
            <div className="reorder-button" style={{ marginBottom: '0.5rem' }}>
                <span
                    className="dx-icon-dragvertical"
                    style={{ cursor: 'grab', fontSize: 'x-large' }}
                    title={'Reorder'}
                ></span>
            </div>
        );
    }

    return (
        <div className="removable-block-container">
            <table className="rbc-table">
                <tbody>
                    <tr>
                        <td className="rbc-cell-remove">
                            {reorderButton}

                            <div>
                                <span
                                    className="glyphicon glyphicon-remove"
                                    title={'Remove'}
                                    onClick={() => {
                                        if (props.onRemove != null) {
                                            props.onRemove(props.id);
                                        }
                                    }}
                                />
                            </div>
                        </td>
                        <td className="rbc-container">
                            <div>{props.children}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export function ReorderedBlockContainerRow(props: { children?: React.ReactNode | React.ReactNode[] }) {
    return (
        <tr className="row-data-source-selector-container">
            <td> {props.children} </td>
        </tr>
    );
}

export function ReorderedBlockContainers(props: {
    value: any[];
    children?: React.ReactNode | React.ReactNode[];
    onReorder(value: any[]): void;
}) {
    const tableRef = React.useRef<HTMLTableSectionElement>(null);

    useElementsReorderingHook(
        tableRef,
        {
            axis: 'y',
            sortableItems: 'tr.row-data-source-selector-container',
            handle: '.reorder-button'
        },
        (start, stop) => {
            const valueCopy = $.extend(true, [], props.value);
            const item = valueCopy.splice(start, 1);

            valueCopy.splice(stop, 0, item[0]);

            props.onReorder(valueCopy);
        },
        [props.value]
    );

    return (
        <div className="reordered-block-containers">
            <table className="rdbc-table table-borderless">
                <tbody ref={tableRef}>{props.children}</tbody>
            </table>
        </div>
    );
}
